module.exports = __webpack_public_path__ + "static/media/plat1.0842edd9.jpeg";